export default __webpack_public_path__ + "static/home-bg-daa5b751b0c5683d6b03847793fc8be6.jpg";